import { render, staticRenderFns } from "./enemyBarChart.vue?vue&type=template&id=19cae15c"
import script from "./enemyBarChart.vue?vue&type=script&lang=js"
export * from "./enemyBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports